import React from 'react';

export interface SearchIconProps {
  size?: number | string;
  viewBox?: string;
  color?: string;
  ariaHidden?: boolean;
}

const Search = (props: SearchIconProps) => {
  const {
    size = '24',
    viewBox = '0 0 24 24',
    color = '#000000',
    ariaHidden = false,
  } = props;
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox={viewBox}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden={ariaHidden}
      focusable={!ariaHidden}
    >
      {!ariaHidden ? <title>ic-search</title> : null}
      <g
        id="ic-search"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ic_search"
          transform="translate(3.000000, 3.000000)"
        >
          <path
            d="M7,1.53 C10.0541347,1.53 12.53,4.00586533 12.53,7.06 C12.53,10.1141347 10.0541347,12.59 7,12.59 C3.94586533,12.59 1.47,10.1141347 1.47,7.06 C1.4755038,4.00814799 3.94814799,1.5355038 7,1.53 M7,0 C3.13400675,0 -1.77635684e-15,3.13400675 -1.77635684e-15,7 C-1.77635684e-15,10.8659932 3.13400675,14 7,14 C10.8659932,14 14,10.8659932 14,7 C14,3.13400675 10.8659932,0 7,0 Z"
            id="Shape"
            fill={color}
            fillRule="nonzero"
          ></path>
          <line
            x1="11.91"
            y1="11.96"
            x2="16.87"
            y2="16.92"
            id="Path"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></line>
        </g>
      </g>
    </svg>
  );
};

export default Search;
